// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"d0-z","subtitle":"e0-z","wrapper":"f0-z","leftArrow":"g0-z","rightArrow":"h0-z"};